<script>
	import Bubble from '$lib/Components/Layout/Bubble/Bubble.svelte';
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import GetAFreeEstimate from '$lib/PageSections/GetAFreeEstimate/GetAFreeEstimate.svelte';
	import exteriorImageGreg from './images/Blog-Post-Flir-A-01-15-19-e1547764513570.jpg';
	import thermalImage from './images/Blog-Post-Flir-B-01-15-19-e1547764611283.jpg';
	import exteriorImageHaleyBrian from './images/Blog-Post-blackwell-window-01-15-19-768x1024.jpg';
</script>

<Section>
	<h2>Indow Customers Solve Drafty Windows, Keep Original Charm</h2>
	<p>
		These customers both had drafty windows, but weren’t sure custom storm
		windows would fix their problems. Would window inserts really fit as well as
		advertised? Would installation go as smoothly as they thought? They thought
		they had found the best way to insulate windows while preserving the
		aesthetic of their beautiful, old windows, so they went ahead took the
		plunge.
	</p>
	<p>
		These individuals live in different areas, in different types of houses, but
		needed to solve their issues with cold and drafty windows. Indow custom
		storm windows brought them comfort and let them keep their original windows.
	</p>
</Section>
<Section>
	<h2>Haley & Brian Preserve Original Windows & Block Drafts</h2>
	<Bubble>
		<ul
			class="
     w-fit list-none
     [&_p]:text-center
   "
		>
			<li>
				<p>Haley & Brian</p>
			</li>
			<li>
				<p>Pittsburgh, PA</p>
			</li>
			<li>
				<p>Historic Homeowners</p>
			</li>
			<li>
				<p>Purchased Inserts November, 2018</p>
			</li>
		</ul>
	</Bubble>

	<p>
		Haley and Brian love their older home, that’s why they are in the process of
		carefully restoring its beautiful windows. But when the Pittsburgh winter
		days hit single digits, they can really feel it. They needed something that
		would preserve the historic features that they are so lovingly repairing
		while bringing comfort and efficiency to their home.
	</p>
	<p>
		“We have gorgeous 12-lite wood casement windows with stone sills and
		original hardware,” says Haley. “It’s a labor of love and 100% worth it. You
		can tell when you look at these windows that they were built specifically
		for our house. These windows are the eyes of our home. Through them, you can
		see the home’s soul, history, and legacy. They were built to last.”
	</p>
	<p>
		This is why it was so important to Haley and Brian to keep the original,
		even drafty windows. “We are passionate about preserving architectural
		character in any way possible,” she says. “Sure – vinyl, double-pane windows
		are cheap, but if you can save the original windows by adding window inserts
		for a similar price, it’s better for the historic integrity and aesthetic of
		the building.”
	</p>
	<Image src={exteriorImageHaleyBrian} />
	<p>
		Haley and Brian tested Indow inserts in two rooms of their home. They say
		they notice a significant improvement and the surrounding rooms are several
		degrees colder. The rest of the house is going to be getting the custom
		storm window treatment soon.
	</p>
</Section>
<Section>
	<h2>Custom Storm Windows Let the Light in for Greg</h2>
	<Bubble>
		<ul
			class="
     w-fit list-none
     [&_p]:text-center
   "
		>
			<li>
				<p>Greg</p>
			</li>
			<li>
				<p>Albuquerque,</p>
			</li>
			<li>
				<p>NM Historic Homeowner</p>
			</li>
			<li>
				<p>Purchased Inserts December, 2018 And Again in January, 2019</p>
			</li>
		</ul>
	</Bubble>
	<p>
		Greg had been using plastic window kits in his windows for years, but wanted
		something better. Albuquerque winters can go weeks without getting above
		freezing.
	</p>
	<p>
		Greg hated the way plastic looked and wanted to be able to see out his
		beautiful, old windows. He has 100-year-old, single-pane windows with lead
		weights. He “loved the look but hated the cold”. He was skeptical if Indow
		custom storm windows would help his drafty windows and got a thermal image
		camera to put them to the test.
	</p>
	<p>
		He installed indow inserts in one room to make sure the fit was perfect and
		to see if they made a difference.
	</p>
	<p>
		Greg was so impressed with the change that he sent us this thermal image
		showing the difference. The window on the left has no insert, but the two
		other windows still have inserts installed.
	</p>
	<Image src={thermalImage} />
	<Image src={exteriorImageGreg} />
	<p>
		Greg says, “I can see out my windows in the winter and let light in on a
		sunny day. My house is no longer a dark cave with little light in the
		winter.” He’s moving forward with the rest of his rooms after this test.
	</p>
	<p>
		We love getting Indow reviews like this. Not only do we get to hear success
		stories from Indow customers, but we get to see a little into their lives,
		homes, and beautiful windows! You can read more Indow window review stories
		or share one of your own.
	</p>
</Section>
<GetAFreeEstimate />
